<template lang="pug">

div
  div( class="form-group" v-if="company.queues && company.queues.length > 0" )
    div
      MModalButton( button-classes="btn-link" modal-size="modal-lg" title="Choosing a Queue" )
        span( slot="button-inner" )
          | Queue
          i( class="fa fa-question-circle inline-block ml-2" )
        p( slot="body" class="text-left font-normal" )
          ul
            p In instances where Moonpull provides you with a number of queues for submitting audits you need to choose a queue.  
            p The queue choice is down to consideration of the needs of other users and the priority you place on your batch.
            p The queue narratives and the information on the outstanding audits in each queue can guide a decision on which queue to use.
    
    div
      table( class="table queue-table" )
        thead
          tr
            th Select
            th Queue
            th Approx audits in queue
            th Description
        tbody
          tr(
            v-for="queue in getQueueData()"
            v-on:click="onRowSelect(queue.letter)"
            v-bind:class="{ 'selected': batchMeta.queueLetter === queue.letter }"
          )
            td
              input(
                type="radio"
                name="queueLetter"
                v-model="batchMeta.queueLetter"
                v-bind:value="queue.letter"
                v-on:change="onChange"
              )
            td {{ queue.letter.toUpperCase() }}
            td {{ queue.count }}
            td {{ queue.description }}

</template>

<style lang="scss" scoped>
table.table.queue-table {
  tbody {
    tr {
      cursor: pointer;
      
      &.selected {
        td {
          background-color: #f0f7fd;
        }
      }
    }
  }
}
</style>

<script>
import Vue from 'vue'
export default Vue.extend({

  props: [ 'company', 'batchMeta', 'queueCounts' ],

  methods: {

    onChange() {
      this.$emit('queueChanged')
    },

    onRowSelect(queueLetter) {
      this.batchMeta.queueLetter = queueLetter
      this.onChange()
    },

    getQueueDescription(queue) {
      if (this.$moonpull.getCurrentUserSession().company.name === 'Moonpull') {
        return `Superuser-only queue.`
      }
      else if (queue === 'a') {
        return 'Typically used for single of <3 link batches where results are wanted as quickly as possible (but are either concurrent or sequential depending on the volume already in the queue).'
      }
      else if (queue === 'b') {
        return 'Typically for intermediate sized batches (e.g. <20) where batches should process reasonably quickly, but are sequential.'
      }
      else if (queue === 'c') {
        return 'Usually for large batches (>50 links) where each batch will be run sequentially.'
      }
    },

    getQueueData() {
      return this.company.queues.map(q => {
        const queueCount = (this.queueCounts || []).find(qc => qc.name.toLowerCase() === q.toLowerCase())
        return {
          letter: q,
          count: (queueCount !== undefined) ? queueCount.count : 'N/A',
          description: this.getQueueDescription(q),
        }
      })
    },

  },

})
</script>
